import { Collapse, CollapseProps, Drawer, Flex, Modal, Tag, Typography } from 'antd';
import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import {
  clearStylingWorkflowPayload,
  setIsStylingWorkflowDrawerOpen,
} from '../../../store/stylist/slice';
import WorkflowBasicInfo from './WorkflowBasicInfo';
import ProductSelection from './ProductSelection';
import ReviewAndCreate from './ReviewAndCreate';

const getPanelStyle = (isActive: boolean): React.CSSProperties => ({
  marginBottom: 24,
  background: isActive ? '#FBFCFC' : '#ffffff',
  borderRadius: 20,
  border: isActive ? 'none' : '1px solid #F4F4F4',
  userSelect: 'none',
});

interface StepTagProps {
  stepNumber: number;
  isActive: boolean;
}

const StepTag = ({ stepNumber, isActive }: StepTagProps) => (
  <Tag
    style={
      isActive
        ? { color: '#ffffff', background: '#171717' }
        : { color: '#171717', background: '#F0F0F0' }
    }
  >
    Step {stepNumber}
  </Tag>
);

const getItems = (
  activeStep: Array<number>,
  workflowGenre: 'standard' | 'occasion',
): CollapseProps['items'] => [
  {
    key: 1,
    label: (
      <Flex gap={8}>
        Workflow Info <StepTag stepNumber={1} isActive={activeStep.includes(1)} />
      </Flex>
    ),
    children: <WorkflowBasicInfo workflowGenre={workflowGenre} />,
    style: getPanelStyle(activeStep.includes(1)),
  },
  {
    key: 2,
    label: (
      <Flex gap={8}>
        Product Selection
        <StepTag stepNumber={2} isActive={activeStep.includes(2)} />
      </Flex>
    ),
    children: <ProductSelection />,
    style: getPanelStyle(activeStep.includes(2)),
  },
  {
    key: 3,
    label: (
      <Flex gap={8}>
        Review and Create
        <StepTag stepNumber={3} isActive={activeStep.includes(3)} />
      </Flex>
    ),
    children: <ReviewAndCreate workflowGenre={workflowGenre} />,
    style: getPanelStyle(activeStep.includes(3)),
  },
];

type CreateStylingWorkflowDrawerProps = {
  workflowGenre?: 'standard' | 'occasion';
};

const CreateStylingWorkflowDrawer = ({
  workflowGenre = 'standard',
}: CreateStylingWorkflowDrawerProps) => {
  const isOpen = useAppSelector(state => state.stylist.isStylingWorkflowDrawerOpen);
  const dispatch = useAppDispatch();

  const [activeStep, setActiveStep] = useState([1]);

  const handleClose = () => {
    Modal.confirm({
      title: 'Are you sure you want to close?',
      content: 'Any unsaved changes will be lost.',
      okText: 'Yes, Close',
      cancelText: 'Cancel',
      onOk: () => {
        dispatch(clearStylingWorkflowPayload());
        dispatch(setIsStylingWorkflowDrawerOpen(false));
      },
    });
  };

  return (
    <Drawer closable={false} onClose={handleClose} open={isOpen} size="large" width={'95vw'}>
      <Typography.Paragraph
        style={{
          fontSize: '24px',
        }}
      >
        {workflowGenre === 'occasion' ? 'Create Occasion Styling Workflow' : 'Create Styling Workflow'}
      </Typography.Paragraph>
      <Collapse
        bordered={false}
        activeKey={activeStep}
        onChange={activeKeys => {
          setActiveStep(activeKeys.map(Number));
        }}
        expandIconPosition="right"
        items={getItems(activeStep, workflowGenre)}
        ghost
      />
    </Drawer>
  );
};

export default CreateStylingWorkflowDrawer;
